export const isProduction = () => import.meta.env.MODE === 'production'

export const isStaging = () =>
  // This function should be a temporary solution until we can determine environment
  // from import.meta.env
  !!window.location.host.match(/intranet-staging-stride/)

export const isDev = () => import.meta.env.DEV

export const isTest = () => import.meta.env.MODE === 'test'
